import PlotlyChart from './PlotlyChart';

export default function BarChart({ data, chartOptions = {} }) {
  const traces = data.map(trace => ({
    x: trace.x,
    y: trace.y,
    type: 'bar',
    name: trace.name
  }))

  const layout = {
    title: 'Bar Chart',
    ...(chartOptions.layout || {}),
  }

  return (
    <PlotlyChart
      data={traces}
      layout={layout}
      config={{
        displayModeBar: false,
      }}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
